export class RefreshResponse {
  access_token: string;
  token_type: string;
  refresh_token: string;
}
